import './EnergyEfficiencyStack.scss';
import { getEnergyEfficiencyLabel } from '@belimo-retrofit-portal/logic';
import { Decimal } from 'decimal.js-light';
import React from 'react';
import { EnergyEfficiencyLabelWrapper } from 'src/modules/common/components/EnergyEfficiencyLabelWrapper';
import { FACTOR_WEIGHTS_LABELS } from 'src/modules/common/constants/factorWeightedLabel';
import { ChevronRightIcon } from 'src/modules/common/icons/ChevronRightIcon';

type Props = {
  readonly value: Decimal | null;
};

export const EnergyEfficiencyStack = ({ value }: Props): React.ReactElement => {
  if (value === null) {
    return (
      <div className="bp-energy-efficiency-stack">
        <div className="bp-energy-efficiency-stack__stack">
          {CLASS_LIST.map((label) => (
            <div key={label}>
              <EnergyEfficiencyLabelWrapper
                value={FACTOR_WEIGHTS_LABELS[label]}
                size="sm"
                disabled={true}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const position = getPosition(value);
  const maxLabel = getEnergyEfficiencyLabel(value.toDecimalPlaces(0, Decimal.ROUND_UP));
  const minLabel = getEnergyEfficiencyLabel(value.toDecimalPlaces(0, Decimal.ROUND_DOWN));

  return (
    <div className="bp-energy-efficiency-stack">
      <div className="bp-energy-efficiency-stack__addition" data-hvac-factor={value?.toFixed(3)}>
        <div className="bp-energy-efficiency-stack__addition-value" style={{ marginBottom: position }}>
          <div className="bp-energy-efficiency-stack__addition-text">
            {minLabel === maxLabel
              ? minLabel
              : <>{minLabel}&ndash;{maxLabel}</>}
          </div>

          <div className="bp-energy-efficiency-stack__addition-value-arrow">
            <ChevronRightIcon/>
          </div>
        </div>
      </div>

      <div className="bp-energy-efficiency-stack__stack">
        {CLASS_LIST.map((label) => (
          <div key={label}>
            <EnergyEfficiencyLabelWrapper
              value={FACTOR_WEIGHTS_LABELS[label]}
              size="sm"
              disabled={label !== maxLabel && label !== minLabel}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const CLASS_LIST = ['A+', 'A', 'B', 'C', 'D'] as const;

const STACK_ITEM_HEIGHT = 1.5;
const STACK_ITEM_MARGIN = 0.25;

function getPosition(value: Decimal): React.CSSProperties['marginBottom'] {
  return `${value.mul(STACK_ITEM_HEIGHT + STACK_ITEM_MARGIN).toFixed(3)}rem`;
}
